var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('password-pane',{attrs:{"user":_vm.user}}),_c('second-factor-table-pane',{attrs:{"user":_vm.user}}),_c('oauth-factor-table-pane',{attrs:{"user":_vm.user}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }